<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="pt-2">
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search" v-model="filters['search']"
              class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table id="sundry-item-predicted-use-report" :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="items" sort :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="15%" sort-key="sundry_item_code">SUNDRY ITEM CODE</vs-th>
                <vs-th width="15%" sort-key="sundry_product_code">SUNDRY PRODUCT CODE</vs-th>
                <vs-th width="20%">SUNDRY PRODUCT NAME</vs-th>
                <vs-th width="20%">SUPPLIER</vs-th>
                <vs-th width="15%">CURRENT STOCK LEVEL</vs-th>
                <vs-th width="15%">SUNDRY ITEM ON ORDER</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td v-if="data[indextr].sundry_order_items.length === 0">
                  </vs-td>

                  <vs-td class="font-semibold text-primary" :data="data[indextr].sundry_item_code">
                    {{ data[indextr].sundry_item_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_product_code">
                    {{ data[indextr].sundry_product_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_product_name">
                    {{ data[indextr].sundry_product_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].supplier">
                    {{ data[indextr].supplier.company_name || '' }}
                  </vs-td>

                  <vs-td :data="data[indextr].current_stock_level">
                    {{ data[indextr].current_stock_level }}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_item_on_order">
                    {{ data[indextr].sundry_item_on_order }}
                  </vs-td>
                  <template class="expand-user" slot="expand" v-if="data[indextr].sundry_order_items.length > 0">
                    <div class="con-expand-users w-full">

                      <div class="vx-row md:mb-3 mt-8 p-8" v-if="data[indextr].sundry_order_items.length > 0">

                        <div class="vx-col  w-full">
                          <vs-row vs-type="flex">
                            <vs-col vs-align="start" vs-justify="center" vs-type="flex" vs-w="2">
                              <feather-icon class="text-success cursor-pointer" icon="ArchiveIcon" />
                            </vs-col>
                            <vs-col vs-align="start" vs-justify="start" vs-type="flex" vs-w="10">
                              <span class="text-md">
                                <h5 class="mb-2">Sundry item orders</h5>
                                <vs-table :data="data[indextr].sundry_order_items">

                                  <template slot="thead">
                                    <vs-th>Order Date</vs-th>
                                    <vs-th>Order Code</vs-th>
                                    <vs-th>Quantity (KG)</vs-th>
                                    <vs-th>Status</vs-th>
                                  </template>

                                  <template slot-scope="{data}">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                                      <vs-td :data="data[indextr].created_at">
                                        {{ __dateTimeFormatter(data[indextr].created_at) }}
                                      </vs-td>

                                      <vs-td :data="data[indextr].sundry_item_order_id">
                                        <a class="mt-4"
                                          :href="`/pages/sundry-items/orders/${data[indextr].sundry_item_order_id}`">{{ data[indextr].sundry_item_order.sundry_order_code }}</a>
                                      </vs-td>

                                      <vs-td :data="data[indextr].quantity">
                                        {{ data[indextr].quantity }}
                                      </vs-td>

                                      <vs-td :data="data[indextr].item_status">
                                        {{ data[indextr].item_status }}
                                      </vs-td>

                                    </vs-tr>
                                  </template>

                                </vs-table>
                              </span>



                            </vs-col>
                          </vs-row>
                        </div>

                      </div>

                      <div class="vx-row hidden">
                        <div class="w-full p-16">
                          <report-single-rm-details-table
                            v-bind:total_orders="data[indextr].total_order_not_manufactured"
                            v-bind:history="data[indextr].history" />
                        </div>
                      </div>
                    </div>
                  </template>

                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of"
              description-title="Records" description :description-items="descriptionItems"
              :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const sundrySupplierRepository = RepositoryFactory.get('sundry')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { defaultPagination, perPageList } from "@/constants/config";

export default {
  name: 'sundry-item-predicted-use-report',
  data() {
    return {
      items: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
    }
  },
  components: {
    'v-select': vSelect
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  async mounted() {
  },
  methods: {
    async refreshData() {
      this.fetchSundryItemsUseReportDetails()
    },
    async fetchSundryItemsUseReportDetails() {
      await this.$vs.loading({
        container: '#sundry-item-predicted-use-report',
        scale: 0.45
      })
      try {
        const { data } = await sundrySupplierRepository.getSundryItemsLowStockReportDetails(this.page, this.filterQuery, this.perPage)
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.showWarningMessage('Something went wrong. Please try again!')
      }
      this.$vs.loading.close('#sundry-item-predicted-use-report > .con-vs-loading')
    },

    filterQueryUpdate() {
      this.fetchSundryItemsUseReportDetails()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchSundryItemsUseReportDetails()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchSundryItemsUseReportDetails()
      }

    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
  },
  watch: {
    page() {
      this.fetchSundryItemsUseReportDetails()
    },
    perPage() {
      this.fetchSundryItemsUseReportDetails()
    }
  }
}
</script>


<style scoped>
.user-edit-popup>>>.vs-popup {
  min-height: 50% !important;
  min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
  .user-edit-popup>>>.vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
  }
}
</style>
